
export function ResetPasswordViewModel(options) {
    var self = this;

    var form$ = options.form$;
    var newPasswordTooltip$ = options.newPasswordTooltip$;
    var login = options.userLogin;

    var commonPwdRules = {
        required: true,
        validation: [
            {
                validator: function (val) { return val !== null && val.match(/^ *$/) === null }
                , message: 'Password should not be empty.'
            }, {
                validator: function (val) { return val !== null && val.length >= 8 }
                , message: 'Password should contain at least 8 symbols.'
            }, {
                validator: function (val) { return val !== null && val.match(/.*[A-Z]{1}.*/) !== null }
                , message: 'Password must contain at least one uppercase character (A-Z).'
            }, {
                validator: function (val) { return val !== null && val.match(/.*[a-z]{1}.*/) !== null }
                , message: 'Password must contain at least one lowercase character (a-z).'
            }, {
                validator: function (val) { return val !== null && val.match(/.*[0-9]{1}.*/) !== null }
                , message: 'Password must contain at least one Base-10 digit (0-9).'
            }, {
                validator: function (val) { return val !== null && val.match(/.*[!$#%]{1}.*/) !== null }
                , message: 'Password must have a non-alphanumeric character (!, $, #, or %).'
            }, {
                validator: function (val) { return val !== null && val !== self.login() }
                , message: 'Password should not be equal to user name.'
            }
        ],
    };

    var reenterPwdRules = {
        validation: [
            {
                validator: function (val) { return val !== null &&  val === self.newPassword() }
                , message: 'This field must match new password.'
            }
        ],
    };
    self.login                = ko.observable(login).extend({ required: true });
    self.oldPassword          = ko.observable(null).extend({ required: true });
    self.newPassword          = ko.observable(null).extend(commonPwdRules);
    self.reenteredNewPassword = ko.observable(null).extend(reenterPwdRules);
    self.passwordValidationRules = ko.observableArray();

    self.init = function () {
        ko.applyBindings(self);
    }

    self.selectedNewPassword = function () {
        self.fillPasswordValidationRules(self.newPassword());

        newPasswordTooltip$.tooltip('show');
    }

    self.blurNewPassword = function () {
        newPasswordTooltip$.tooltip('hide');
    }

    self.fillPasswordValidationRules = function (password) {
        const selectedItems = [];

        for (let rule of commonPwdRules.validation) {
            const item = {
                isValid: rule.validator(password),
                message: rule.message
            };

            selectedItems.push(item);
        }

        self.passwordValidationRules(selectedItems);
        self.passwordValidationRules.valueHasMutated(); 
    }

    self.changePassword = function (item: any, event: any) {
        var currentValue = event.target.value;

        self.fillPasswordValidationRules(currentValue);

        newPasswordTooltip$.tooltip('show');

        return true;
    }

    self.onSubmit = function () {
        self.login.isModified(true);
        self.oldPassword.isModified(true);
        self.newPassword.isModified(true);
        self.reenteredNewPassword.isModified(true);

        if (isModelValid())
            form$.submit();
    }

    var isModelValid = function () {

        return self.login.isValid() &&
            (!self.isValidateOldPassword || self.oldPassword.isValid()) &&
            self.newPassword.isValid() &&
            self.reenteredNewPassword.isValid();
    }
}